
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("14FoF", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5e5965bc314469b$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $DEWI6 = parcelRequire("DEWI6");

var $bChGW = parcelRequire("bChGW");

var $d61Yr = parcelRequire("d61Yr");

var $3wQkW = parcelRequire("3wQkW");

var $dAgso = parcelRequire("dAgso");

var $LBp7X = parcelRequire("LBp7X");

var $h3Xi4 = parcelRequire("h3Xi4");
const $a5e5965bc314469b$var$optionStyles = {
    root: "_aetrb3bt _1ywu1ule _18postnw _1x88x0bf _19doze3t _z0ai1osq _1qdgu2gc _1hfkvuon _lvi81y44 _1u0p1y44",
    focused: "_t56om7j4"
};
const $a5e5965bc314469b$var$FixVersionsView = (props)=>{
    const { canAdministerProject: canAdministerProject, canAdministerJira: canAdministerJira, createNewItemMessage: createNewItemMessage, createNewItemIconLabel: createNewItemIconLabel, value: value, projectId: projectId, versionFieldIds: versionFieldIds, customEditView: customEditView, onVersionCreated: onVersionCreated, onChange: onChange, getDataFromCache: getDataFromCache, fetchSuggestions: fetchSuggestions } = props;
    const [isDialogOpen, setIsDialogOpen] = (0, $5uXOq.useState)(false);
    const [data, setData] = (0, $5uXOq.useState)([]);
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)(false);
    const [inputQueryStr, setInputQueryStr] = (0, $5uXOq.useState)('');
    const [createReleaseModalQueryReference, setCreateReleaseModalQueryReference] = (0, $5uXOq.useState)(null);
    (0, $5uXOq.useEffect)(()=>{
        const getDataFromCacheInternal = async ()=>{
            try {
                const cachedData = await getDataFromCache?.();
                setData(cachedData ?? []);
            } catch (err) {
                setError(true);
            } finally{
                setLoading(false);
            }
        };
        getDataFromCacheInternal();
    }, [
        getDataFromCache
    ]);
    const fetchSuggestionsCallback = (0, $5uXOq.useCallback)(async (query, sessionId)=>{
        const suggestions = await fetchSuggestions(query, sessionId);
        const filteredAndSlicedData = (0, $h3Xi4.prefilterAndLimitItems)(suggestions, inputQueryStr);
        setData(filteredAndSlicedData);
        return filteredAndSlicedData;
    }, [
        fetchSuggestions,
        inputQueryStr
    ]);
    const openDialog = (0, $5uXOq.useCallback)(()=>{
        setIsDialogOpen(true);
    }, []);
    const closeDialog = (0, $5uXOq.useCallback)(()=>{
        setIsDialogOpen(false);
    }, []);
    const setQueryRef = (0, $5uXOq.useCallback)((queryRef)=>{
        setCreateReleaseModalQueryReference(queryRef);
    }, []);
    const onInputChange = (0, $5uXOq.useCallback)((queryStr)=>{
        setInputQueryStr(queryStr);
    }, []);
    const onSuccess = (0, $5uXOq.useCallback)((version)=>{
        const versionARI = {
            ari: version.ari
        };
        onChange([
            ...value,
            {
                content: version.name,
                value: version.id,
                ...versionARI
            }
        ]);
        closeDialog();
        onVersionCreated(version, versionFieldIds);
    }, [
        closeDialog,
        onChange,
        onVersionCreated,
        value,
        versionFieldIds
    ]);
    const initialData = (0, $5uXOq.useMemo)(()=>({
            data: data,
            loading: loading,
            error: error
        }), [
        data,
        loading,
        error
    ]);
    const footer = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $LBp7X.CreateVersionButton), {
            createNewItemLabel: createNewItemMessage,
            onCreate: setQueryRef,
            createNewItemIconLabel: createNewItemIconLabel
        }), [
        createNewItemMessage,
        setQueryRef,
        createNewItemIconLabel
    ]);
    const renderSelect = (0, $5uXOq.useMemo)(()=>{
        return (selectProps)=>{
            const shouldShowFooter = canAdministerProject || canAdministerJira;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wQkW.default), {
                ...selectProps,
                classNamePrefix: "issue-view-fix-versions",
                styles: (0, $d61Yr.selectFooterStyles),
                onInputChange: onInputChange,
                shouldShowFooter: shouldShowFooter,
                footer: footer,
                components: {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Option: (optionProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, {
                            ...optionProps,
                            xcss: optionProps.data.__isNew__ === true && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                            (0, $DEWI6.cx)($a5e5965bc314469b$var$optionStyles.root, optionProps.isFocused && $a5e5965bc314469b$var$optionStyles.focused)
                        })
                },
                onFooterSelect: openDialog,
                allowEmptyValue: true,
                optionValuesSafeForAnalytics: true,
                fetchSuggestions: fetchSuggestionsCallback,
                debounceFetchSuggestionsTime: 300,
                initialData: initialData,
                customEditView: customEditView
            });
        };
    }, [
        canAdministerProject,
        canAdministerJira,
        onInputChange,
        openDialog,
        fetchSuggestionsCallback,
        initialData,
        customEditView,
        footer
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isDialogOpen && createReleaseModalQueryReference != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dAgso.CreateReleaseModal), {
        queryReference: createReleaseModalQueryReference,
        onClose: closeDialog,
        projectId: String(projectId),
        onReleaseCreation: onSuccess
    }), renderSelect(props));
};
var $a5e5965bc314469b$export$2e2bcd8739ae039 = $a5e5965bc314469b$var$FixVersionsView;

});
parcelRegister("LBp7X", function(module, exports) {

$parcel$export(module.exports, "CreateVersionButton", () => $9e36d32ed3b3399f$export$4950e58c7f6a3cf);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $99M5v = parcelRequire("99M5v");

var $d61Yr = parcelRequire("d61Yr");

var $47Rfm = parcelRequire("47Rfm");

var $b4adL = parcelRequire("b4adL");

var $90yGq = parcelRequire("90yGq");
const $9e36d32ed3b3399f$var$ISSUE_VIEW = 'issueView';
const $9e36d32ed3b3399f$export$4950e58c7f6a3cf = ({ createNewItemLabel: createNewItemLabel, createNewItemIconLabel: createNewItemIconLabel, onCreate: onCreate })=>{
    const accountId = (0, $90yGq.useAccountId)();
    const [createReleaseFormQueryRef, loadQuery] = (0, $8Uumt.useQueryLoader)((0, $47Rfm.default));
    const experienceStart = (0, $b4adL.useCreateReleaseExperienceStart)($9e36d32ed3b3399f$var$ISSUE_VIEW);
    const loadCreateReleaseQuery = ()=>{
        if (!createReleaseFormQueryRef && accountId) loadQuery({
            accountId: accountId
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d61Yr.FooterContainer), {
        /* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */ className: "issue-view__select-footer",
        onClick: ()=>{
            experienceStart();
            loadCreateReleaseQuery();
            onCreate(createReleaseFormQueryRef);
        },
        onFocus: loadCreateReleaseQuery,
        onMouseOver: loadCreateReleaseQuery
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99M5v))), {
        label: createNewItemIconLabel || '',
        LEGACY_size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d61Yr.OptionLabel), null, createNewItemLabel));
};

});

parcelRegister("h3Xi4", function(module, exports) {

$parcel$export(module.exports, "prefilterAndLimitItems", () => $ebaa61090337dce2$export$5afacdde33fc0cb9);
const $ebaa61090337dce2$export$5f1d715c3da4ade5 = 20;
const $ebaa61090337dce2$export$5afacdde33fc0cb9 = (data, inputQueryStr)=>data.map((categoryData)=>({
            ...categoryData,
            items: categoryData.items.filter((x)=>x.content.toLowerCase().includes(inputQueryStr.toLowerCase()))// apply sort to ensure that exact matches are not sliced off
            .sort((a, b)=>Number(b.content.toLowerCase() === inputQueryStr.toLowerCase()) - Number(a.content.toLowerCase() === inputQueryStr.toLowerCase())).slice(0, $ebaa61090337dce2$export$5f1d715c3da4ade5)
        }));

});



$parcel$global.rlb("6TXdv")
//# sourceMappingURL=view.668a429e.js.map
